import { Injectable } from '@angular/core';
import type * as L from 'leaflet';

@Injectable()
export class StadiaMapsContextService {
  mapInstance: L.Map;
}
